import type { DomainRouterJsonInput } from '@triedge/domain-core';
import type {
  AcademicGradeEntryWorkspace,
  GetGradeEntryWorkspaceInput,
  SaveGradeEntryDraftInput,
  SubmitGradeEntryInput,
} from './index';

export const ACADEMICS_QUERY_OPERATION_IDS = [
  'getGradeEntryWorkspace',
] as const;

export const ACADEMICS_MUTATION_OPERATION_IDS = [
  'saveGradeEntryDraft',
  'submitGradeEntry',
] as const;

export type AcademicsQueryOperationId = (typeof ACADEMICS_QUERY_OPERATION_IDS)[number];
export type AcademicsMutationOperationId = (typeof ACADEMICS_MUTATION_OPERATION_IDS)[number];

export type AcademicsQueryArgsMap = {
  getGradeEntryWorkspace: GetGradeEntryWorkspaceInput;
};

export type AcademicsQueryResultMap = {
  getGradeEntryWorkspace: AcademicGradeEntryWorkspace;
};

export type AcademicsMutationArgsMap = {
  saveGradeEntryDraft: { input: SaveGradeEntryDraftInput | DomainRouterJsonInput };
  submitGradeEntry: { input: SubmitGradeEntryInput | DomainRouterJsonInput };
};

export type AcademicsMutationResultMap = {
  saveGradeEntryDraft: AcademicGradeEntryWorkspace;
  submitGradeEntry: AcademicGradeEntryWorkspace;
};
